/* ==========================================
   Atlas Market — Delivery Day Checker
   Builds postcode -> days map from AM_DELIVERY_ZONES
   Supports Saturday, Monday, Tuesday, Wednesday
========================================== */

(function () {
  const DATA = window.AM_DELIVERY_ZONES || {};
  const ZONES = {};

  function addDay(listKey, label) {
    const arr = DATA[listKey] || [];

    arr.forEach((pc) => {
      const cleanPc = String(pc || "").trim();
      if (!cleanPc) return;

      if (!ZONES[cleanPc]) ZONES[cleanPc] = [];
      if (!ZONES[cleanPc].includes(label)) {
        ZONES[cleanPc].push(label);
      }
    });
  }

  // Build the lookup map
  addDay("SAT", "Saturday");
  addDay("MON", "Monday");
  addDay("TUE", "Tuesday");
  addDay("WED", "Wednesday");

  function cleanPostcode(postcode) {
    return String(postcode || "")
      .trim()
      .replace(/\s+/g, "");
  }

  function lookup(postcode) {
    const clean = cleanPostcode(postcode);
    return ZONES[clean] || [];
  }

  function renderResult(days) {
    const result = document.getElementById("am_result");
    if (!result) return;

    if (!days.length) {
      result.innerHTML =
        '<span style="color:#b00020;">Sorry, we don’t currently deliver to that postcode.</span>';
      return;
    }

    result.innerHTML =
      "<strong>Available delivery day(s):</strong> " + days.join(", ");
  }

  function bindEvents() {
    const btn = document.getElementById("am_check");
    const input = document.getElementById("am_pc");

    if (!btn || !input) return;
    if (btn.dataset.amBound === "1") return;

    btn.dataset.amBound = "1";

    btn.addEventListener("click", function () {
      const pc = cleanPostcode(input.value);

      if (!/^\d{4}$/.test(pc)) {
        const result = document.getElementById("am_result");
        if (result) {
          result.innerHTML =
            '<span style="color:#b00020;">Please enter a valid 4-digit postcode.</span>';
        }
        return;
      }

      renderResult(lookup(pc));
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        btn.click();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", bindEvents);
  document.addEventListener("shopify:section:load", bindEvents);

  const obs = new MutationObserver(function () {
    bindEvents();
  });

  obs.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();